<app-loader [fullScreen]="true" *ngIf="spinnerLoading"></app-loader>
<div class="modal-header text-center">
  <h4 class="modal-title w-100">New Reserve Name</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<form [formGroup]="modalForm">
<div class="modal-body">
  <div class="_card white-bg">
    <div class="row">
      <div class="col-md-12 mb-3">
        
          <div class="input-container">
            <label class="label text-uppercase" for="reserve-name">
              New Reserve Name</label
            >
            <input
              type="text"
              maxlength="30"
              class="input"
              formControlName="reserveName"
            />
            <div class="invalid-feedback">
              Please enter a name for the reserve
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <button
      class="btn btn-secondary"
      (click)="cancelReserve(); bsModalRef.hide()"
    >
      CANCEL
    </button>
    <button
      class="btn btn-primary"
      (click)="doneReserve()"
      [disabled]="!modalForm.valid"
    >
      DONE
    </button>
  </div>
</div>
</form>